import { getPkce } from './oauth-pkce.js'

export interface PKCE {
  verifier: string
  challenge: string
}

/**
 * A PKCE verifier and challenge for sign-in. GH #2840: when the SHA-256 digest fails (no secure context, some
 * webviews), `getPkce` calls back with only an error. That used to be destructured before the error check, and thrown
 * where nothing could catch it, so the promise never settled and sign-in hung. It now rejects with a clear error.
 */
export const pkce = async () =>
  new Promise<PKCE>((resolve, reject) => {
    getPkce(43, (error: Error | null, value?: PKCE) => {
      if (error || !value) {
        reject(new Error(`Sign-in could not start: the browser could not create the PKCE challenge`, { cause: error }))
        return
      }
      resolve({ verifier: value.verifier, challenge: value.challenge })
    })
  })
